import { render, staticRenderFns } from "./examCategoryList.vue?vue&type=template&id=37b89ba0&scoped=true&"
import script from "./examCategoryList.vue?vue&type=script&lang=js&"
export * from "./examCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./examCategoryList.vue?vue&type=style&index=0&id=37b89ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b89ba0",
  null
  
)

export default component.exports